import React, {useContext, useEffect, useState} from 'react'
import RolesFunctionTable from "./RolesFunctionTable";
import SaveRolesFunction from "./SaveRolesFunction"
import {SettingRoleContext} from "../../context/SettingRoleContext";

function RolesFunctionPage(props) {
    const {innerHeight} = props
    const SettingRolePageContext = useContext(SettingRoleContext)
    const {listRolesFunction} = SettingRolePageContext
    const [selectAll, setSelectAll] = useState(false)
    const [arrSelected, setArrSelected] = useState([])

    const _handleCheckALl = (isChecked) => {
        if (isChecked) {
            const selectedLead = listRolesFunction.map(itemL => itemL.objectId)
            setArrSelected(selectedLead)
            setSelectAll(true)
        } else {
            setArrSelected([])
            setSelectAll(false)
        }
    }

    const _updateSelected = (id, isAdded) => {
        if (isAdded && !arrSelected.includes(id)) {
            setArrSelected([...arrSelected, id])
            setSelectAll(arrSelected.length + 1 === listRolesFunction.length)
        } else {
            const filtered = arrSelected.filter(item => item !== id)
            setArrSelected(filtered)
            setSelectAll(false)
        }
    }

    const _setSelected = () => {
        const roleStatusUsed = listRolesFunction.filter(item => item.selected).map(item1 => item1.objectId)
        setSelectAll(roleStatusUsed.length === listRolesFunction.length && listRolesFunction.length > 0)
        setArrSelected(roleStatusUsed)
    }

    useEffect(() => {
        _setSelected()
        // eslint-disable-next-line
    }, [listRolesFunction])

    return <div className="RolesFunctionPage">
        <div className="PageHeading mb-3 align-items-end">
            <h5 className="mb-0">Phân quyền chức năng</h5>
            <SaveRolesFunction arrSelected={arrSelected}/>
        </div>
        <div className="PageTable mb-4" style={{maxHeight: (parseInt(innerHeight) - 210) / 2 + 'px', overflow: 'auto'}}>
            <RolesFunctionTable
                selectAll={selectAll}
                arrSelected={arrSelected}
                onCheckALl={_handleCheckALl}
                onSelected={_updateSelected}
            />
        </div>
    </div>
}

export default RolesFunctionPage
